export const brutalTemplates = {
  jumping4: {
    layout: `
.......B......BB......B.......
..............................
..SSSSSSSSSSSSSSSSSSSSSSSSSS..
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  lasers4: {
    layout: `
.....L.L......L.L......L.L....
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  projectiles_lasers4: {
    layout: `
...............L..............
..BB...........L..........pB..
..BB...........L..........pB..
..BB...........L..........pB..
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  projectile_stair_up4: {
    layout: `
..BB.......................p..
..BB..................BBBB.BBB
..BB.......................BBB
..BB.............BBBB......BBB
..BB.......................BBB
..BB........BBBB...........BBB
..BB.......................pBB
.......BBBB................BBB
...........................BBB
BBBBB......................BBB
BBBBB......................BBB
`,
    metadata: {},
  },
  stair_down4: {
    layout: `
.....S........................
BBB..BBB......................
..........S...................
..........BBB.................
...............S..............
...............BBB............
....................S.........
....................BBB.......
.........................SS...
.........................BBBBB
.........................BBBBB
`,
    metadata: {},
  },
  projectile_stair_down4: {
    layout: `
..B........................pB.
BBB..BBB...................BB.
BBB........................BB.
BBB.......BBB..............BB.
BBB........................pB.
BBB............BBB............
BBB...........................
BBB.................BBB.......
BBB...........................
BBB......................BBBBB
BBB......................BBBBB
`,
    metadata: {},
  },
  // A chasm bridged by two single-block stepping stones. The edge columns are
  // the only fill columns; the gaps stay lethal at any height.
  chasm4: {
    layout: `
BB........B........B........BB
BB..........................BB
`,
    metadata: {},
  },
  spikes4: {
    layout: `
....SSSSS...SSSSSS...SSSSS....
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Solid step (+3) with a spike gauntlet on the approach before the climb.
  step_up4: {
    layout: `
....................S.........
.................BBBBBBBBBBBBB
.................BBBBBBBBBBBBB
......S..S.......BBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Platform climbs/descents (+6 / -6) over wide gaps with a spike on the
  // stepping stone — precise jumps.
  raised_platform_up4: {
    layout: `
.......................BBBBBBB
.......................BBBBBBB
.............S.........BBBBBBB
...........BBBBBB......BBBBBBB
.......................BBBBBBB
.......................BBBBBBB
BBBBB..................BBBBBBB
BBBBB..................BBBBBBB
`,
    metadata: {},
  },
  raised_platform_down4: {
    layout: `
BBBBBBB.......................
BBBBBBB.......................
BBBBBBB.........S.............
BBBBBBB....BBBBBB.............
BBBBBBB.......................
BBBBBBB.......................
BBBBBBB..................BBBBB
BBBBBBB..................BBBBB
`,
    metadata: {},
  },

  // Two-lane projectile gauntlets that change plane — stacked turrets fire two
  // rows at once into a backstop, with a spike on the high ledge.
  projectile_up4: {
    layout: `
........................S.....
......................BBBBBBBB
..BB..........pB......BBBBBBBB
..BB..........pB......BBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  projectile_down4: {
    layout: `
....S.........................
BBBBBBBB......................
BBBBBBBB..............pB......
BBBBBBBB..............pB......
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Wall-jump climb under crossfire (+7): the wall_climb shaft with two turrets
  // mounted on the front wall firing left across the gap you have to cross. You
  // can't hang on a wall and wait — the rounds sweep the shaft — so the climb
  // has to be paced through the gaps in the fire. Each spawner has the front
  // wall as its right-hand mount and the back wall as its left-hand backstop, so
  // every round dies inside the scene. See wall-jump notes in easy_templates.js.
  wall_bullets_climb4: {
    layout: `
.............BBBB.............
.............BBBB.............
.............BBBB.............
.............BBBB.............
.............BBBB....BBBBBBBBB
.............BBBB...pBBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB...pBBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.....................BBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 8 },
  },

  // wall_descent_bullets4 (-7): ride the wall down while a turret mounted on the
  // shaft's right wall rakes the gap to your left — cling the right wall to stay
  // out of the lane, break left only on the gaps in the fire. The entry mass is
  // the backstop that kills each round inside the scene. See wall_descent3 for
  // the descent shape.
  wall_descent_bullets4: {
    layout: `
..............BBB.............
..............BBB.............
..............BBB.............
..............BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB...pBBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....................
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 8 },
  },

  // wall_climb_spikes4 (+8): a wide 5-cell shaft over a spike bed on the run-in,
  // with a spike on the exit ledge — the wider gap plus the floor spikes make
  // the entry and each carry punishing. See easy_templates.js.
  wall_climb_spikes4: {
    layout: `
............BBBB..............
............BBBB..............
............BBBB..............
............BBBB..............
............BBBB..........S...
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
.....S..S............BBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 9 },
  },
};
